import { env } from '@/constants';
import { NeonHttpUtils } from '@art-basel/artbasel-lib-neon';

// TODO: consolidate this with router-utils & HttpUtils
export const urlWithRedirect = (url: string, target?: string | null) => {
  const [path, params] = url.split('?');
  const searchParams = new URLSearchParams();

  if (params) {
    params.split('&').forEach((param) => {
      const [k, v] = param.split('=');
      searchParams.append(k, v);
    });
  }

  if (target) {
    searchParams.set('redirectTo', target);
  }

  return path + (Array.from(searchParams).length !== 0 ? `?${searchParams.toString()}` : '');
};

// TODO: move to Neon HttpUtils
export const urlWithUtm = (
  url: string,
  { source, medium, campaign }: { source?: string; medium?: string; campaign?: string },
): string => {
  return NeonHttpUtils.urlWithQueryParams(url, {
    utm_source: source,
    utm_medium: medium,
    utm_campaign: campaign,
  });
};

export const slugify = (text: string): string => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};

export const arcualDomain = () => {
  let label = '';
  const environment = env.VITE_AZURE_ENV === 'production' ? '.' : `.${env.VITE_AZURE_ENV}.`;

  label += `${environment}artbasel.app`;

  return label;
};
